import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getCustomer = createAsyncThunk(
  "admin/customer",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/customer", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getCustomerById = createAsyncThunk(
  "admin/customer/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/customer/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortCustomer = createAsyncThunk(
  "admin/customer/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/customer/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postCustomer = createAsyncThunk(
  "admin/customer/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/customer", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  "admin/customer/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/customer/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateCustomer = createAsyncThunk(
  "admin/customer/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/customer/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const customerSlice = createSlice({
  name: "Customer Store",
  initialState: initialState,
  reducers: {
    addCustomer(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortCustomer(state, action) {
      state.data.docs = action.payload;
    },
    deleteCustomer(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editCustomer(state, action) {
        let index = state.data.docs.findIndex(item => item._id === action.payload._id);
        state.data.docs[index] = action.payload;
    },
  },
  extraReducers: {
    [getCustomer.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getCustomer.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getCustomer.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getCustomerById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getCustomerById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getCustomerById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortCustomer.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortCustomer.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortCustomer.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postCustomer.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postCustomer.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postCustomer.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteCustomer.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteCustomer.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteCustomer.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateCustomer.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateCustomer.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateCustomer.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const customerActions = customerSlice.actions;

export default customerSlice.reducer;
